import React from "react";
class NotAccessible extends React.Component {
  render() {
    return <b>Sorry, You do not have access rights to view this screen</b>;
  }
}

export default NotAccessible;
